import { token, musteriToken, readStoredString } from '@/services/useToken';

const TOKEN_TTL_MS = 86400 * 1000;

function decodeJwtPayload(jwt) {
  try {
    const parts = jwt.split('.');
    if (parts.length !== 3) return null;
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
}

function isTokenValid(raw) {
  if (!raw || typeof raw !== 'string') return false;
  const trimmed = raw.trim();
  if (!trimmed || trimmed === 'null' || trimmed === 'undefined') return false;

  const payload = decodeJwtPayload(trimmed);
  if (!payload) return false;

  if (payload.exp && payload.exp * 1000 < Date.now()) {
    return false;
  }

  if (payload.API_TIME != null) {
    const apiTime = Number(payload.API_TIME);
    if (!Number.isFinite(apiTime)) return false;
    if (Date.now() - apiTime * 1000 >= TOKEN_TTL_MS) {
      return false;
    }
  }

  return true;
}

function getAgencyTokenRaw() {
  return readStoredString('token') || (token.value || '').trim();
}

function getMusteriTokenRaw() {
  return readStoredString('musteritoken') || (musteriToken.value || '').trim();
}

export function isAgencyAuthenticated() {
  return isTokenValid(getAgencyTokenRaw());
}

export function isMusteriAuthenticated() {
  return isTokenValid(getMusteriTokenRaw());
}

export function clearInvalidTokens() {
  const agencyRaw = getAgencyTokenRaw();
  const musteriRaw = getMusteriTokenRaw();

  if (agencyRaw && !isTokenValid(agencyRaw)) {
    token.value = '';
  }
  if (musteriRaw && !isTokenValid(musteriRaw)) {
    musteriToken.value = '';
  }
}

export function clearAllTokens() {
  token.value = '';
  musteriToken.value = '';
}
